module.exports = __webpack_public_path__ + "img/icon-talkbubble.df77ce7c.svg";